import { Trans as _Trans } from "@lingui/react";
import { useCallback, useEffect, useState } from 'react';
import { useGetAveragePriceCounter } from './useGetAveragePriceCounter';
import { useAppConfiguration, useInterval } from '@wkda/funnel-components';
import { getLocaleForNumberFormatting } from '@wkda/funnel-utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function PricedCarsCounter(_ref) {
  let {
    element = 'h1',
    ...formattedPricepParams
  } = _ref;
  const {
    formatted: pricedCarCount
  } = usePricedCarsCounter(formattedPricepParams);
  const E = element;
  return /*#__PURE__*/_jsx(E, {
    className: "priced-cars-title",
    children: /*#__PURE__*/_jsx(_Trans, {
      id: "carleadCreation.form.pricedCarCount.title",
      message: "Bewerte dein Auto in <0>weniger als einer Minute</0>, wie es heute <1/><2><3>{pricedCarCount}</3> Kunden</2> getan haben",
      values: {
        pricedCarCount: pricedCarCount
      },
      components: {
        0: /*#__PURE__*/_jsx("strong", {}),
        1: /*#__PURE__*/_jsx("br", {}),
        2: /*#__PURE__*/_jsx("strong", {}),
        3: /*#__PURE__*/_jsx("span", {
          className: "priced-cars-title-counter"
        })
      }
    })
  });
}
export function usePricedCarsCounter(params) {
  var _averagePriceCounter$, _averagePriceCounter$2;
  const hardcodedInitialCount = 1024;
  const baseIntervalRateInMilis = 1 /* second */ * 1000; /* in miliseconds */
  const baseLeadsIntervalInSecs = 1 /* hour */ * 60 /*in minutes */ * 60; /* in seconds */

  const {
    data: averagePriceCounter,
    status
  } = useGetAveragePriceCounter(params === null || params === void 0 ? void 0 : params.updateInterval);
  const {
    fullLocale
  } = useAppConfiguration();
  const hasCount = (averagePriceCounter === null || averagePriceCounter === void 0 ? void 0 : averagePriceCounter.currentLeads) !== undefined;
  const currentCarleads = (_averagePriceCounter$ = averagePriceCounter === null || averagePriceCounter === void 0 ? void 0 : averagePriceCounter.currentLeads) !== null && _averagePriceCounter$ !== void 0 ? _averagePriceCounter$ : hardcodedInitialCount;
  const leadsPerHour = (_averagePriceCounter$2 = averagePriceCounter === null || averagePriceCounter === void 0 ? void 0 : averagePriceCounter.leadsPerHour) !== null && _averagePriceCounter$2 !== void 0 ? _averagePriceCounter$2 : 0;
  const [currentCounter, setCounter] = useState(currentCarleads !== null && currentCarleads !== void 0 ? currentCarleads : 0);

  /**
   * effect used to only update the counter with the latest carleads from backend
   * **/
  useEffect(() => {
    if (hasCount) {
      setCounter(currentCarleads);
    }
  }, [currentCarleads, hasCount]);
  const intervalDelay = leadsPerHour > 0 ? baseIntervalRateInMilis / (leadsPerHour / baseLeadsIntervalInSecs) : baseIntervalRateInMilis;
  const intervalCb = useCallback(() => {
    setCounter(prevTime => {
      return prevTime + 1;
    });
  }, []);
  useInterval(intervalCb, intervalDelay);
  const {
    locale = fullLocale,
    formatOptions = {}
  } = params !== null && params !== void 0 ? params : {};
  return {
    counter: currentCounter,
    formatted: currentCounter.toLocaleString(getLocaleForNumberFormatting(locale), {
      style: 'decimal',
      useGrouping: true,
      ...formatOptions
    }),
    status
  };
}